import { useContext } from "react";
import { DrawerContext } from "./DrawerProvider";
export const useDrawer = () => {
    const drawerContext = useContext(DrawerContext);
    if (typeof drawerContext === "undefined") {
        throw new Error("useDrawer hook is used outside of DrawerProvider");
    }
    return drawerContext;
};
//# sourceMappingURL=useDrawer.js.map